import { all } from "redux-saga/effects";
import { authSaga } from "store/state/auth";
import { forgotPasswordSaga } from "store/state/forgotPassword";
import { changePasswordSaga } from "store/state/changePassword";
import { profileSettingsSaga } from "store/state/profileSettings";
import { avpSaga } from "store/state/avp";
import { companiesSaga } from "store/state/companies";
import { configItemsSaga } from "store/state/configItems";
import { cashflowsSaga } from "store/state/cashflows";
import { dealSaga } from "store/state/deal";
import { enumeratedTypesSaga } from "store/state/enumeratedTypes";
import { fundSaga } from "store/state/fund";
import { loanSaga } from "store/state/loan/loan";
import { loanDetailsSaga } from "store/state/loan/loanDetails";
import { loanContactsSaga } from "store/state/loan/loanContacts";
import { metricsSaga } from "store/state/metrics/metrics";
import { prepaymentSchedulesSaga } from "store/state/loan/prepaymentSchedules";
import { personalGuarantorsSaga } from "store/state/loan/personalGuarantors";
import { companyGuarantorsSaga } from "store/state/loan/companyGuarantors";
import { propertySaga } from "store/state/property";
import { usersSaga } from "store/state/users";
import { contactsSaga } from "store/state/contacts";
import { roleSaga } from "store/state/roles";
import { noteSaga } from "store/state/note";
import { metaSaga } from "store/state/meta";
import { liborSaga } from "store/state/libor";
import { forwardCurveSaga } from "store/state/calculators/forwardCurve";
import { bankSwapSaga } from "store/state/calculators/bankSwap";
import { prepaymentSaga } from "store/state/calculators/prepayment";
import { cashFlowsSaga } from "store/state/calculators/cashFlows";
import { capPricerSaga } from "store/state/calculators/capPricer";
import { suppPricerSaga } from "store/state/calculators/suppPricer";
import { quotesSaga } from "store/state/quote";
import { searchSaga } from "store/state/search";
import { testHarnessSaga } from "store/state/calculators/testHarness";
import { portfolioSaga } from "store/state/portfolio";
import { hedgeSaga } from "store/state/hedge";
import { notificationsSaga } from "store/state/notifications";
import { creditRatingsSaga } from "store/state/creditRatings";
import { capCalcSettingsSaga } from "store/state/capCalcSettings";
import { heartbeatSaga } from "store/state/heartbeat";
import { guestSaga } from "store/state/guest";
import { guestGroupSaga } from "store/state/guestGroup";
import { propertiesSaga } from "store/state/properties";
import { fileSaga } from "store/state/file";
import { splashScreenSaga } from "store/state/splashScreen";
import { hedgeEscrowSaga } from "store/state/hedgeEscrow";

// REDESIGNED PAGES
import { activeLoanModuleSaga } from "modules/activeLoan/activeLoan.store";
import { paidLoanModuleSaga } from "modules/paidLoan/paidLoan.store";
import { peopleModuleSaga } from "modules/people/people.store";
import { propertyModuleSaga } from "modules/property/property.store";
import { reminderModuleSaga } from "modules/reminder/reminder.store";
import { quoteModuleSaga } from "modules/quote/quote.store";
import { dashboardSaga } from "pages/dashboard/Dashboard.store";
import { hedgeDetailSaga as newHedgeDetailSaga } from "pages/hedgeDetail/hedgeDetail.store";
import { loanDetailSaga as newLoanDetailSaga } from "pages/loanDetail/loanDetail.store";
import { newDealSaga } from "pages/deal/deal.store";
import { dealSettingsSaga } from "pages/dealSettings/dealSettings.store";
import { dealAnalysisSaga } from "pages/dealAnalysis/dealAnalysis.store";
import { propertyDetailSaga as newPropertyDetailSaga } from "pages/propertyDetail/propertyDetail.store";
import { quoteDetailSaga } from "pages/quoteDetail/quoteDetail.store";
import { quotesSaga as newQuotesSaga } from "pages/quotes/quotes.store";
import { quoteHistorySaga as newQuoteHistorySaga } from "pages/quoteHistory/quoteHistory.store";
import { loanProceedsCalculatorSaga } from "modals/LoanProceedsCalculatorModal/loanProceedsCalculator.store";
import { refiCashoutCalculatorSaga } from "modals/RefiCashOutCalculatorModal/refiCashoutCalculator.store";
import { prepaymentCalculatorSaga } from "modals/PrepaymentCalculatorModel/prepaymentCalculatorModel.store";
import { supplementalCalculatorSaga } from "modals/SupplementalCalculatorModal/supplementalCalculatorModal.store";
import { whatIfCalculatorSaga } from "modals/WhatIfCalculatorModal/WhatIfCalculator.store";
import { changeDealStatusModalSaga } from "modals/ChangeDealStatusModal/changeDealStatusModal.store";
import { uploadSpreadsheetModalSaga } from "modals/UploadSpreadsheetModal/UploadSpreadsheetModal.store";
import { treasurySnapshotSaga } from "modals/TestHarnessCashflowModal/treasurySnapshot.store";
import { newFundSaga } from "shared-utility/store/state/fund";
import { newPortfolioSaga } from "shared-utility/store/state/portfolio";
import { newScreenPreferencesSaga } from "shared-utility/store/state/screenPreferences";
import { lenderReportingSetupSaga } from "pages/lenderReporting/reportingSetup/reportingSetup.store";
import { lenderReportListSaga } from "pages/lenderReporting/dashboard/dashboard.store";
import { lenderReportingDrawerSaga } from "pages/lenderReporting/drawer/lenderReportingDrawer.store";
import { lenderReportFieldManagementSaga } from "pages/lenderReporting/drawer/field-management/fieldManagement.store";
import { lenderReportSourceFileManagementSaga } from "pages/lenderReporting/drawer/source-file-management/sourceFileManagement.store";
import { lenderReportSourceFileFieldSaga } from "pages/lenderReporting/drawer/field-management/source-file-field/sourceFileField.store";
import { lenderReportSourceFileVersionsSaga } from "pages/lenderReporting/drawer/source-file-management/sourceFileVersions.store";
import { lenderReportingReportComponentSaga } from "pages/lenderReporting/reportingComponents/reportComponent.store";
import { lenderReportingNoiCalculationSaga } from "pages/lenderReporting/reportingComponents/noiCalculationDashboard/noiRegularCalculationDashboard/noiRegularCalculationDashboard.store";
import { lenderReportingNoiCalculationSaga as lenderReportingNoiProjectedCalculationSaga } from "pages/lenderReporting/reportingComponents/noiCalculationDashboard/noiProjectedCalculationDashboard/noiProjectedCalculationDashboard.store";
import { lenderReportDebtYieldLineItemsSaga } from "pages/lenderReporting/drawer/debt-yield-line-items-management/debtYieldLineItemManagement.store";
import { lenderReportDscrLineItemsSaga } from "pages/lenderReporting/drawer/dscr-line-items-management/dscrLineItemManagement.store";
import { rentRollsSaga } from "pages/propertyDetail/property-rent-rolls/rentRolls.store";
import { rentRollFieldSaga as lenderReportRentRollFieldSaga } from "pages/lenderReporting/drawer/field-management/rent-roll-field/rentRollField.store";
import { uploadRentRollModalSaga } from "modals/RentRolls/uploadRentRollModal.store";
import { apiTestHarnessSaga } from "components/Admin/ApiTestHarness/testHarness.store";
import { vendorIntegrationsSaga } from "components/Admin/VendorIntegrations/vendorIntegrations.store";
import { loanProceedsSaga } from "components/Admin/CashOutProceeds/LoanProceedsSettings/LoanProceedsSettings.store";
import { dealScreenerSaga } from "pages/dealScreener/DealScreener.store";
import { sreoScreenerSaga } from "pages/sreoScreener/screener.store";

import { companySponsorSaga } from "../components/Admin/CompanySponsors/companySponsors.store";
import { dealSharingSaga } from "../modals/DealSharing/dealSharing.store";
import { holidayCalendarSaga } from "../components/Admin/HolidayCalendar/holidayCalendar.store";
import { cashflowTestHarnessSaga } from "../components/Admin/Cashflows/cashflowTestHarness.store";
import { debtValuationSaga } from "../pages/debtValuation/debtValuation.store";
import { lenderReportingDashboardSaga } from "../pages/lenderReportingDashboard/lenderReportingDashboard.store";
import { appsSettingsSaga } from "../components/Admin/AppsSettings/appsSettings.store";
import { appsPageSaga } from "../pages/apps/appPage.store";
import { emailCampaignSaga } from "../pages/campaigns/emailCampaign.store";

import { accountingIntegrationSaga } from "./state/accountingIntegration";

import { brokerDashboardSaga } from "../pages/brokerDashboard/brokerDashboard.store";

export default function* RootSaga() {
  yield all([
    authSaga(),
    forgotPasswordSaga(),
    changePasswordSaga(),
    avpSaga(),
    cashflowsSaga(),
    companiesSaga(),
    configItemsSaga(),
    dealSaga(),
    enumeratedTypesSaga(),
    fundSaga(),
    loanSaga(),
    loanDetailsSaga(),
    loanContactsSaga(),
    metricsSaga(),
    prepaymentSchedulesSaga(),
    personalGuarantorsSaga(),
    companyGuarantorsSaga(),
    propertySaga(),
    roleSaga(),
    noteSaga(),
    metaSaga(),
    liborSaga(),
    forwardCurveSaga(),
    bankSwapSaga(),
    prepaymentSaga(),
    cashFlowsSaga(),
    capPricerSaga(),
    suppPricerSaga(),
    usersSaga(),
    contactsSaga(),
    quotesSaga(),
    searchSaga(),
    testHarnessSaga(),
    portfolioSaga(),
    hedgeSaga(),
    hedgeEscrowSaga(),
    notificationsSaga(),
    creditRatingsSaga(),
    capCalcSettingsSaga(),
    profileSettingsSaga(),
    heartbeatSaga(),
    guestSaga(),
    guestGroupSaga(),
    propertiesSaga(),
    fileSaga(),
    splashScreenSaga(),

    // REDESIGNED PAGES
    dashboardSaga(),
    newDealSaga(),
    dealSettingsSaga(),
    dealAnalysisSaga(),
    newHedgeDetailSaga(),
    newLoanDetailSaga(),
    newPropertyDetailSaga(),
    newQuotesSaga(),
    newQuoteHistorySaga(),
    quoteDetailSaga(),
    lenderReportListSaga(),
    lenderReportingSetupSaga(),
    lenderReportingDrawerSaga(),
    lenderReportFieldManagementSaga(),
    lenderReportSourceFileManagementSaga(),
    lenderReportSourceFileFieldSaga(),
    lenderReportRentRollFieldSaga(),
    lenderReportSourceFileVersionsSaga(),
    lenderReportingNoiCalculationSaga(),
    lenderReportingNoiProjectedCalculationSaga(),
    lenderReportingReportComponentSaga(),
    lenderReportDebtYieldLineItemsSaga(),
    lenderReportDscrLineItemsSaga(),
    rentRollsSaga(),
    uploadRentRollModalSaga(),

    // calculators
    loanProceedsCalculatorSaga(),
    refiCashoutCalculatorSaga(),
    prepaymentCalculatorSaga(),
    supplementalCalculatorSaga(),
    whatIfCalculatorSaga(),
    changeDealStatusModalSaga(),
    uploadSpreadsheetModalSaga(),
    treasurySnapshotSaga(),

    newFundSaga(),
    newPortfolioSaga(),
    newScreenPreferencesSaga(),

    activeLoanModuleSaga(),
    paidLoanModuleSaga(),
    peopleModuleSaga(),
    propertyModuleSaga(),
    quoteModuleSaga(),
    reminderModuleSaga(),

    apiTestHarnessSaga(),
    vendorIntegrationsSaga(),
    loanProceedsSaga(),
    dealScreenerSaga(),

    sreoScreenerSaga(),

    companySponsorSaga(),
    dealSharingSaga(),
    holidayCalendarSaga(),
    cashflowTestHarnessSaga(),
    accountingIntegrationSaga(),
    debtValuationSaga(),
    lenderReportingDashboardSaga(),

    appsSettingsSaga(),
    appsPageSaga(),
    emailCampaignSaga(),
    
    brokerDashboardSaga()
  ]);
}
